import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaSearch, FaFileAlt, FaDownload, FaUpload, FaHistory } from 'react-icons/fa';
import { AuthContext } from '../../context/AuthContext';
import { isSeriesActive } from '../../utils/helpers';
import '../../components/common/DashboardQuickLinks.css';

function SecurityDashboard() {
  const { user } = useContext(AuthContext);
  const [activeSeries, setActiveSeries] = useState(null);

  useEffect(() => {
    axios.get('/api/exam-series')
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        setActiveSeries(list.find((series) => isSeriesActive(series)) || null);
      })
      .catch(() => setActiveSeries(null));
  }, []);

  // The OSM/RLP/CAD-by-centre pages are scoped to a series id, so they can
  // only be offered as direct quick-links while a series is actually
  // active - otherwise they're omitted rather than shown as dead links.
  const quickLinks = [
    { title: 'Upload Scoring Guides', text: 'Upload OSM/RLP scoring guides.', path: '/security/scoring-guides', icon: <FaUpload /> },
    { title: 'Audit Trail', text: 'View the scoring guide access history.', path: '/security/reports/scoring-guide-audit', icon: <FaHistory /> },
    { title: 'Browse per Candidate', text: 'Search and download an individual candidate’s work.', path: '/security/cad/candidates', icon: <FaSearch /> },
    ...(activeSeries ? [
      { title: `OSM - ${activeSeries.name}`, text: 'Download marksheets and scoring guides.', path: `/security/osm/series/${activeSeries.id}`, icon: <FaFileAlt /> },
      { title: `RLP - ${activeSeries.name}`, text: 'Download marksheets and scoring guides.', path: `/security/rlp/series/${activeSeries.id}`, icon: <FaFileAlt /> },
      { title: `Browse by Centre - ${activeSeries.name}`, text: 'Download CAD candidate work bundles per centre.', path: `/security/cad/centres/${activeSeries.id}`, icon: <FaDownload /> }
    ] : [])
  ];

  return (
    <Container fluid className="py-5" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <Row className="justify-content-center mb-4">
        <Col lg={8} md={10} sm={12} className="text-center">
          <h1 className="display-4 mb-3">Welcome, {user?.fullName || 'Security'}!</h1>
        </Col>
      </Row>
      <Row className="justify-content-center">
        {quickLinks.map((link) => (
          <Col md={4} sm={6} className="mb-4" key={link.path}>
            <Link to={link.path} className="text-decoration-none">
              <Card className="shadow-sm border-0 h-100 dashboard-quick-link">
                <Card.Body className="text-center">
                  <div className="h3 text-primary mb-2">{link.icon}</div>
                  <Card.Title className="h5 text-dark">{link.title}</Card.Title>
                  <Card.Text className="text-muted">{link.text}</Card.Text>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default SecurityDashboard;
